import ErrorBgEn from 'assets/images/unauthorizedEn.svg';
import ErrorBgFr from 'assets/images/unauthorizedFr.svg';

import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { stylesError, stylesErrorTitle } from '@/utils/globalStyles';

export function UnidentifiedFallback() {
  const { t, i18n } = useTranslation('layouts');
  const { t: tComponents } = useTranslation('components');

  return (
    <Box
      sx={{ backgroundImage: `url(${i18n.language === 'fr' ? ErrorBgFr : ErrorBgEn})`, ...stylesError }}
      role='alert'
    >
      <Box component='h1' sx={stylesErrorTitle}>
        {tComponents('errorFallback.title')}
      </Box>
      <Typography variant='h1' component='p' color='#f1416c' width='45%'>
        {t('auth.azure.B2C.notIdentified.message')}
      </Typography>
    </Box>
  );
}
